import { isMobileScreen } from '@apply/ui';

export interface RepresentativeCellProps {
    representative: string | undefined;
}

export const RepresentativeCell: React.FC<RepresentativeCellProps> = ({ representative }) => {
    const mobileScreen = isMobileScreen();
    return (
        <>
            {representative && (
                <div className={`activatedBrokerReferralsTable-representative ${mobileScreen ? 'mobile' : ''}`}>
                    <div className='activatedBrokerReferralsTable-representative-name'>{representative}</div>
                </div>
            )}
            {!representative && <div className='activatedBrokerReferralsTable-representative-none'>No Referrals Found</div>}
        </>
    );
};
